



















































import { CONFIG } from '@/config';
import { Http } from '@/decorators';
import { Size } from '@/enums';
import { http } from '@/services';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { notificationService } from '../../../../services';
import { DAP_ROUTES } from '../../router';

@Component
export default class DapProjectSubmit extends Vue {
  state: any = {
    data: {
      idProject: 0,
      name: '',
      dateSubmitForApproval: new Date(),
      approvalFlowEventDtos: []
    }
  };

  @Prop({ default: false })
  public open: boolean;

  @Prop({ required: false })
  public nameProject: string;

  @Prop({ required: false })
  public id: number;

  public Size = Size;
  public moment = moment;

  @Emit('submit')
  public onSubmit() {
    http.post(`${CONFIG.URL.NEODASH_API}/api/dap/approval/${this.id}/submitForApproval`, this.state.data);
    notificationService.sendToast({
      status: 1,
      type: 'success',
      message: 'Projeto submetido para aprovação com sucesso!'
    });

    setTimeout(() => {
      this.$router.push({
        name: DAP_ROUTES.PROJECTS,
        params: {
          reloadProjects: String('true')
        }
      });
    }, 1000);
  }

  @Emit('cancel')
  public onCancel() {} // tslint:disable-line

  @Watch('id')
  public onIdChange(id: number) {
    this.state.data.idProject = id;
    this.state.data.approvalFlowEventDtos.forEach((item: any) => {
      item.qtdDays = 0;
    });
  }

  @Watch('nameProject')
  public onNameChange(nameProject: string) {
    this.state.data.name = nameProject;
  }

  @Http('get', ({ id }) => `${CONFIG.URL.NEODASH_API}/api/dap/approval/events/${id}`)
  public created(params?: any, error?, data?) {
    if (error || !data) {
      return;
    }

    this.state.data.idProject = this.id;
    this.state.data.approvalFlowEventDtos = _(data)
      .orderBy((item: any) => item.order)
      .value();
  }
}
